// extracted by mini-css-extract-plugin
export default {"list":"Vr9O_6CS","expanded":"WBNPn3Mn"};